import { ResponseDTO } from './response-dto';
import { UserApproverDTO } from './user-approver-dto';

export interface ReadUserApproversResponseDTO extends ResponseDTO {
    userApprovers?: UserApproverDTO[];
}
